import { OfferedProjectType } from "../../../../clients/graphqlTypes.js";

export type MatrixSelection = {
  categoryId: string;
  projectType: OfferedProjectType;
};

export type OnboardingFlowWizardState = {
  selectedVerticals: string[];
  selectedProjectTypes: OfferedProjectType[];
  applyToAll: "unset" | "yes" | "no";
  specifyMode: "unset" | "now" | "later";
  // Matrix-stage row toggle. A category appears here iff the user has
  // declared they offer it; this is independent of `matrixSelections`
  // (declared rows may have zero project-type cells set).
  matrixDeclaredCategories: string[];
  matrixSelections: MatrixSelection[];
};

export const initialOnboardingFlowWizardState: OnboardingFlowWizardState = {
  selectedVerticals: [],
  selectedProjectTypes: [],
  applyToAll: "unset",
  specifyMode: "unset",
  matrixDeclaredCategories: [],
  matrixSelections: [],
};

// Discriminated union of reducer actions. Names are imperative-mood; one case
// per action in onboardingFlowWizardReducer.
export type OnboardingFlowWizardAction =
  | { type: "toggleVertical"; categoryId: string }
  | { type: "toggleProjectType"; projectType: OfferedProjectType }
  | { type: "setApplyToAll"; value: "yes" | "no" }
  | { type: "setSpecifyMode"; value: "now" | "later" }
  // Wholesale replace of both declared rows and selections. The cascade
  // CatalogueGrid computes the next buffer (activation cascade, auto-fill,
  // leaf-only actions, session memory) and emits it as one unit; `selections`
  // may retain cells for undeclared categories (session memory) — the commit
  // selector filters those out.
  | {
      type: "setMatrixBuffer";
      declaredCategories: string[];
      selections: MatrixSelection[];
    }
  | { type: "reset" };

// Discriminant for which path the user took through the wizard to arrive at
// the setOrganisationOfferedServices mutation — drives the path → payload
// mapping in selectOfferedServicesPayload.
export type OfferedServicesCommitPath =
  | "skip-project-types"
  | "apply-to-all-yes"
  | "specify-later"
  | "specify-now-commit"
  | "skip-matrix";

export type OfferedServicesPayload = {
  categories: string[];
  services: { categoryId: string; projectType: OfferedProjectType }[];
};
